import React from "react";
import { Alert, Snackbar } from "@mui/material";

function ToastSnackbar({ handleOpen, onClose, message, error }) {
  const messageColor = message.includes("Error") ? "error" : "success";
  return (
    <Snackbar
      open={handleOpen}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      onClose={onClose}>
      <Alert
        onClose={onClose}
        severity={messageColor}
        variant="filled"
        sx={{ width: "100%", whiteSpace: "pre-wrap" }}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default ToastSnackbar;
